module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-alert', {
    staticClass: "mb-2",
    attrs: {
      "title": "Atenção",
      "type": "warning",
      "description": "Aqui você pode inserir uma nova categoria para classificar uma coluna se houver necessidade."
    }
  }), _vm._v(" "), _c('CategoriaEdit', {
    attrs: {
      "tabela": _vm.tabela,
      "parent": this
    }
  }), _vm._v(" "), _c('ed-table', {
    attrs: {
      "registerName": "Inserir Nova Categoria",
      "onRegister": (this.validarPermissao(571) ? _vm.onRegister : null),
      "onEdit": _vm.onEdit,
      "onDelete": _vm.onDelete,
      "onSearch": _vm.getTabelaDinamicaCategoria,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "loadingEditAll": _vm.loadingEditAll,
      "pagination": _vm.pagination,
      "response": _vm.response
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46bd3186"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/ltcat/tabela-dinamica/categoria/index.vue
// module id = 1459
// module chunks = 45